export enum BookingDocumentBillingIdType {
  CC = 'CC',
  CE = 'CE',
  NIT = 'NIT',
  F_DOC = 'F_DOC',
  CUIL = 'CUIL',
  CUIT = 'CUIT',
  PAS = 'PAS',
  CNPJ = 'CNPJ',
  CPF = 'CPF',
  IFE = 'IFE',
  INE = 'INE',
  RFC = 'RFC',
  DNI_PE = 'DNI_PE',
  RUC_PE = 'RUC_PE',
  RUC_UY = 'RUC_UY',
  RUT_CL = 'RUT_CL',
  NONE_ENABLED = 'NONE_ENABLED'
}
